
<div class="w-100 lm-border pa-3" style="height: 200px;">
    <v-row class="no-frame">
        <c-site-tzb-title
            :title         = "title"
            :rating        = "gadget.rating"
            :padding-right = "0"
        />
    </v-row>
    <v-row class="no-frame">
        <f-read-only-field
            :value = "typeName"
            :label = "label"
            class  = "w-100"
            :line  = "false"
            dense
        />
    </v-row>
    <v-row class="no-frame mt-1" v-if="gadget.additionalInfo">
        <f-read-only-field
            :value = "gadget.additionalInfo"
            :label = "sublabel"
            class  = "w-100"
            :line  = "false"
            dense
        />
    </v-row>
    <v-row class="no-frame mt-1">
        <v-col class="no-frame pr-2">
            <f-read-only-field
                :label = "$t('unit.tzb.manufacturer')"
                :value = "gadget.manufacturer ? gadget.manufacturer.name : na"
                :line  = "false"
                dense
            />
        </v-col>
        <v-col class="no-frame pr-2">
            <f-read-only-field
                :label = "$t('unit.tzb.model')"
                :value = "gadget.model ? gadget.model : na"
                :line  = "false"
                dense
            />
        </v-col>
    </v-row>
    <slot name="additional">
    </slot>
</div>
